export default (user) => `${user.person?.first_name} ${user.person?.last_name}`;
